module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center justify-content-start flex-wrap"
  }, [_c('p', [_vm._v("Add color to items:")]), _vm._v(" "), _vm._l((_vm.colors), function(color) {
    return [_c('ItemColor', {
      key: color,
      attrs: {
        "color": color
      },
      on: {
        "click": function($event) {
          _vm.markItems(color);
        }
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f609d1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/itemsColor/ItemColors.vue
// module id = 3257
// module chunks = 0